export const initialHomesState = {
    homesById: {},
    homeIdsByUserId: {},
    homeIdsByProjectId: {},
};
